import { offsetShadow, TYPE } from "@chess/shared";
import { useTheme } from "@/theme/ThemeProvider";

export type ToastKind = "success" | "danger" | "info" | "accent";

export interface ToastData {
  kind: ToastKind;
  text: string;
}

export function ToastView({ toast }: { toast: ToastData | null }) {
  const p = useTheme();
  if (!toast) return null;
  const variants: Record<ToastKind, { bg: string; fg: string }> = {
    success: { bg: p.success, fg: p.successFg },
    danger: { bg: p.danger, fg: p.dangerFg },
    info: { bg: p.info, fg: p.infoFg },
    accent: { bg: p.accent, fg: p.accentFg },
  };
  const v = variants[toast.kind];
  const icon =
    toast.kind === "success" ? "✓" : toast.kind === "danger" ? "✕" : toast.kind === "accent" ? "★" : "ⓘ";
  return (
    <div
      style={{
        position: "fixed",
        top: 80,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1000,
        background: v.bg,
        color: v.fg,
        border: `2px solid ${p.border}`,
        boxShadow: offsetShadow(p, 6, 6),
        padding: "12px 20px",
        fontFamily: TYPE.body,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: 0.6,
        fontSize: 13,
        animation: "toastIn .25s ease",
        display: "flex",
        alignItems: "center",
        gap: 12,
        maxWidth: "90vw",
      }}
    >
      <span style={{ fontSize: 18, fontFamily: TYPE.mono }}>{icon}</span>
      {toast.text}
    </div>
  );
}
